import React from "react";
export const RealTimeTrackingDetailContext = React.createContext(null);
export const useRealTimeTrackingDetailContext = () => {
  const context = React.useContext(RealTimeTrackingDetailContext);
  if (!context) throw new Error("Realtime Tracking context not provided!");
  return context;
};
